import { ConcreteEncodable } from "./ConcreteEncodable";

import { RateSourceImplEncoder } from "../../encoder/RateSourceImplEncoder";

import * as CubiqTS from "../../index";
import { RateSource } from "../RateSource";

export class RateSourceImpl extends ConcreteEncodable implements RateSource {
  public static enType: string = "com.bcdfx.model.RateSourceImpl";

  /*FID=1*/
  public id: string;
  /*FID=2*/
  public description: string;
  /*FID=3*/
  public benchmarkCurve: boolean;
  /*FID=4*/
  public autoFillCurve: boolean;
  /*FID=5*/
  public marketCurve: boolean;
  /*FID=6*/
  public enabled: boolean;
  /*FID=7*/
  public spotCurve: boolean;
  /*FID=8*/
  public forwardCurve: boolean;
  /*FID=9*/
  public ndfForwardCurve: boolean;
  /*FID=11*/
  public corePrice: boolean;
  /*FID=12*/
  public manualSpotPricing: boolean;
  /*FID=13*/
  public streamingCurve: boolean;
  /*FID=14*/
  public liquidityProvidingCurveFg: boolean;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = RateSourceImplEncoder.Instance;
    this.setEncodableType(RateSourceImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "RateSourceImpl[" +
      "id=" +
      this.id +
      "description=" +
      this.description +
      "benchmarkCurve=" +
      this.benchmarkCurve +
      "autoFillCurve=" +
      this.autoFillCurve +
      "marketCurve=" +
      this.marketCurve +
      "enabled=" +
      this.enabled +
      "spotCurve=" +
      this.spotCurve +
      "forwardCurve=" +
      this.forwardCurve +
      "ndfForwardCurve=" +
      this.ndfForwardCurve +
      "corePrice=" +
      this.corePrice +
      "manualSpotPricing=" +
      this.manualSpotPricing +
      "streamingCurve=" +
      this.streamingCurve +
      "liquidityProvidingCurveFg=" +
      this.liquidityProvidingCurveFg +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
